// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"43":"ca3a7262","234":"2396edd0","287":"c39cbde2","488":"d1d67098","551":"af1e3f66","653":"8bec6e00","844":"768ec8a1"}[chunkId] + ".chunk.js";
};